import React from "react";
import clsx from "clsx";
import { makeStyles, ThemeProvider as StylesThemeProvider } from "@mui/styles";
import UserRoleProfile from "../SystemAdminstration/userroleProfile";
import { getUserDetails } from "../../services/userApiService";
import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BusinessUnit from "../Businessunits/businessUnits";
import Typography from "@mui/material/Typography";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { useHistory } from "react-router-dom";

import useMediaQuery from "@mui/material/useMediaQuery";
import { ThemeProvider } from "@mui/material/styles";
import WorkloadFileImport from "../WorkLoade_File_Import/workload-fileImport";
import BulkFormImport from "../WorkLoade_File_Import/bulkFormImport";
import AdminSystemLinks from "../SystemAdminstration/System_Links/systemLinks";
import ExportFunctionality from "../Export/export";
import ReportsProcess from "../Report/reports";
import ApprovalReviewProcess from "../Aproval_Review/approvalReview";
import { useEffect, useState, useRef } from "react";
import RejectionsFunction from "../Rejection/rejections";
import { CustomModal, fontFamily, menuItemStyle, useSharedValue } from "../Constants/constants";
import ExtractionApprovalReviewProcess from "../Extraction_View/extractionApproval";
import Chat from "../CopilotWindow";
import InstaColors from "../Constants/constants";
import DispalyAndEditFile from "../WorkLoade_File_Import/display_and_edit_file";
import DisplayExtractionView from "../Extraction_View/displayExtractionView";
import Organisation from "../organisation/organisation";
import Notifications from "./notification_window";
import "../Main_Page/home.css";
import { CircularProgress } from "@mui/material";
import ProfileDropdown from "./userSetting";
import { BASE_URL } from "../../App_Settings/app_settings";
import settingsUserProfileIcon from "../../assets/new icons/settings/user profile.svg";
import settingsClientIcon from "../../assets/new icons/settings/client.svg";
import settingsAdminIcon from "../../assets/new icons/settings/admin setting.svg";
import settingsInvoiceIcon from "../../assets/new icons/settings/invoice.svg";
import { createTheme } from "@mui/material/styles";
import UserSettings from "../AdminSettings/AdminSettings";
import ShepherdTour from "../../App_Tour/ShepherdTour";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import DashboardPage from "../Dashboard/dashboard";
import Invoice from "../invoice/Invoice.tsx";
import complyExtractorLogoExpanded from "../../assets/new icons/side menu/comply extractor logo.svg";
import ceLogoCollapsed from "../../assets/new icons/side menu/CE.svg";
import dashboardIcon from "../../assets/new icons/side menu/dashbaord.svg";
import fileImportIcon from "../../assets/new icons/side menu/file import.svg";
import bulkFormImportIcon from "../../assets/new icons/side menu/bulk import.svg";
import extractionReviewIcon from "../../assets/new icons/side menu/extraction review.svg";
import approvalProcessIcon from "../../assets/new icons/side menu/approval review.svg";
import rejectionsIcon from "../../assets/new icons/side menu/rejections.svg";
import exportIcon from "../../assets/new icons/side menu/export.svg";
import reportsIcon from "../../assets/new icons/side menu/reports.svg";
import settingsIcon from "../../assets/new icons/side menu/setting.svg";
import helpIcon from "../../assets/new icons/side menu/help.svg";
import logoutIcon from "../../assets/new icons/side menu/logout.svg";
import collapseMenuOnIcon from "../../assets/new icons/side menu/menu open.svg";
import collapseMenuOffIcon from "../../assets/new icons/side menu/menu close.svg";
import ceBubbleIcon from "../../assets/new icons/CoPilot Icon.svg";
import notificationIcon from "../../assets/new icons/Notification.svg";
import downArrowIcon from "../../assets/new icons/arrow.svg";

let drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  popover: {
    width: "200px",
    height: "120px",
    alignItems: "center",
  },
  toolbar: {
    // paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: "white",
    minHeight: "0px",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",

    justifyContent: "flex-end",
    //padding: '0 8px',
    ...theme.mixins.toolbar,
  },

  appBar: {
    boxShadow: "none",
    background: "transparent",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`, // Adjust based on your drawerWidth
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    color: "white",
  },

  drawerPaper: {
    backgroundImage: "linear-gradient(#2AA7E0,#095896)",
    boxShadow: "none",
    borderRight: "none",
    position: "relative",
    whiteSpace: "nowrap",
    width: 240,
    height: "100vh",
    overflowY: "scroll", // Enable vertical scrolling
    scrollbarWidth: "none", // Hide scrollbar for Firefox
    msOverflowStyle: "none", // Hide scrollbar for Internet Explorer and Edge
    transition: theme.transitions.create("width", {
      duration: theme.transitions.duration.enteringScreen,
    }),
    "& .MuiListItemIcon-root": {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "&::-webkit-scrollbar": {
      display: "none", // Hide scrollbar for Chrome, Safari, and Edge
    },
  },

  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 72,
    [theme.breakpoints.up("sm")]: {
      width: 72,
    },
    "& .MuiListItemText-root": {
      display: "none",
    },
    "& .MuiListItem-root": {
      paddingLeft: 0,
      paddingRight: 0,
      justifyContent: "center",
    },
    "& .MuiListItemIcon-root": {
      minWidth: "50px",
      marginLeft: "0 !important",
      margin: 0,
      padding: 0,
      justifyContent: "center",
      display: "flex",
      alignItems: "center",
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",

    overflow: "auto",
  },
  chatbotWindow: {
    width: "300px", // Adjusted to string with unit
    height: "100%",
    position: "fixed",

    right: "5px", // Adjusted to string with unit
    border: "1px solid #ccc",
    borderRadius: "10px", // Adjusted to string with unit
    overflow: "hidden",

    display: "flex",
    backgroundColor: "#F2F3F4",
    flexDirection: "column",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 480,
  },
  fixedHeight: {
    height: 480,
  },
  flexContainer: {
    display: "flex",
    flexDirection: "row",
  },
  firstDiv: {
    flex: 1, // Take up remaining space
  },
  secondDiv: {
    width: "320px", // Set fixed width of 250px
  },
}));

export default function Dashboard(props) {
  const { notifications, handleNotificationList } = useSharedValue();
  const { handleCheckTourCompleted, isTourCompleted, handleTourGuide } = useSharedValue();
  const { selectedRows, handleSelectedRows } = useSharedValue();
  const [selectedMenu, setSelectedMenu] = React.useState(false);
  const settingsRef = useRef(null);
  const helpRef = useRef(null);

  const [previousSelectedMenu, setpreviousSelectedMenu] = React.useState(false);
  const [selectAdminItem, setSelecteAdminItem] = React.useState(null);
  const { isMenuOpen, updateDrawerMenu } = useSharedValue();
  const { isDirectNavigation, updateDirectNavigation } = useSharedValue();

  // Step 1: Add a state variable for chat window visibility
  const { isChatWindowVisible, updateDisplayChatWindowValue } = useSharedValue();
  const { isNotificationWindowVisible, updateNotificationWindowValue } = useSharedValue();
  const history = useHistory();
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const {
    defaultBusinessunit,
    getBusinessUnits,
    handleSetValueDefaultBusinessunit,
    businessUnitsList,
    defaultOrganization,
    handleSetValueDefaultOrganization,
    handleSetValueDefaultUser,
    defaultUser,
  } = useSharedValue();

  const [openPopup, setOpenPopup] = useState(false);

  const [popupMessage, setPopupMessage] = useState("");
  const [isSettingsHovered, setIsSettingsHovered] = useState(false);
  const settingsHideTimer = React.useRef(null);
  const showSettingsMenu = () => {
    if (settingsHideTimer.current) clearTimeout(settingsHideTimer.current);
    setIsSettingsHovered(true);
  };
  const hideSettingsMenu = () => {
    settingsHideTimer.current = setTimeout(() => setIsSettingsHovered(false), 150);
  };
  const hideSettingsMenuNow = () => {
    if (settingsHideTimer.current) clearTimeout(settingsHideTimer.current);
    setIsSettingsHovered(false);
  };
  const [isHelpHovered, setIsHelpHovered] = useState(false);
  const helpHideTimer = React.useRef(null);
  const showHelpMenu = () => {
    if (helpHideTimer.current) clearTimeout(helpHideTimer.current);
    setIsHelpHovered(true);
  };
  const hideHelpMenu = () => {
    helpHideTimer.current = setTimeout(() => setIsHelpHovered(false), 150);
  };
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const { isProcessing, handleProcessingDialogue, isPackProcessStarted } = useSharedValue();

  const menuItems = [
    { id: "users", icon: settingsUserProfileIcon, label: "Users Profile" },
    { id: "business", icon: settingsClientIcon, label: "Clients" },
    { id: "userSettings", icon: settingsAdminIcon, label: "Admin Settings" },
    { id: "organization", icon: settingsClientIcon, label: "Organisation" },
    { id: "invoice", icon: settingsInvoiceIcon, label: "Invoice" },
  ];

  const [systemAdminAnchorEl, setSystemAdminAnchorEl] = useState(null);
  const menuTitles = {
    dashboard: "Dashboard",
    workloadFileImport: "File Import",
    bulkFormImport: "Bulk Form Import",
    home: "File Import",
    displayAndEditFile: "Upload Review",
    extractionReview: "Extraction Review",
    approval: "Approval Process",
    rejections: "Rejections",
    export: "Export",
    displayExtractionView: "Extraction View",
    reports: "Reports",
    userRoleProfile: "Settings | Users Profile",
    businessUnit: "Settings | Clients",
    systemLink: "Settings | System Links",
    organisation: "Settings | Organization",
    invoice: "Settings | Invoice",
    billing: "Settings | Billing",
    userSettings: "Settings | Admin Settings",
  };
  const handleSystemAdminClick = (event) => {
    // Check role access
    if (hasAccess("settings")) {
      setSystemAdminAnchorEl(event.currentTarget);
    } else {
      showPermissionAlert();
    }

    // setSelectedMenu('systemadmin')
    // setSelecteAdminItem('')
  };

  useEffect(() => {
    handleCheckTourCompleted();
  }, [isTourCompleted]);

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  document.addEventListener("contextmenu", (event) => event.preventDefault());
  // Disable F12 key and Ctrl+Shift+I combo
  // document.addEventListener('keydown', event => {
  //   if (event.keyCode === 123 || (event.ctrlKey && event.shiftKey && event.keyCode === 73)) {
  //     event.preventDefault();
  //   }
  // });
  useEffect(() => {
    getBusinessUnits();
    // uploadPreLoadedFiles();

    // getDataRows();
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      getUser(userData.userId, userData.organizationId);
      createBusinessUnit(userData);
      setUserName(userData.firstName + " " + userData.lastName);
      setUserEmail(userData.userName);

      // Make sure 'email' property exists in your data.
    }
  }, []);

  const LOCAL_STORAGE_KEY = "notifications_list";

  // Load notifications from local storage when the component mounts
  useEffect(() => {
    const storedNotifications = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (storedNotifications) {
      const parsed = JSON.parse(storedNotifications);
      handleNotificationList(Array.isArray(parsed) ? parsed : []);
    }
  }, []);

  // Save notifications to local storage whenever the notifications list changes
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(notifications));
  }, [notifications]);

  // Load notifications from local storage when the component mounts
  useEffect(() => {
    const storedSelectedFiles = localStorage.getItem("SelectedFilesList");
    if (storedSelectedFiles) {
      handleSelectedRows(JSON.parse(storedSelectedFiles));
    }
  }, []);

  // Save notifications to local storage whenever the notifications list changes
  useEffect(() => {
    localStorage.setItem("SelectedFilesList", JSON.stringify(selectedRows));
  }, [selectedRows]);

  const getUser = async (userId, organizationId) => {
    // Use centralized user API service
    const user = await getUserDetails();

    if (user) {
      if (user.isSuperAdmin) {
        setIsSuperAdmin(user.isSuperAdmin);
        if (user.isSuperAdmin) setUserRole("Admin");
      }
      if (user.userRoles && user.userRoles.length > 0) {
        // Define the role priority order (higher roles come first)
        const rolePriority = ["Admin", "Checker", "Maker"];

        // Sort the roles the user has based on priority
        const sortedRoles = user.userRoles
          .map((role) => role.name) // Extract role names
          .sort((a, b) => rolePriority.indexOf(a) - rolePriority.indexOf(b)); // Sort based on priority order

        setUserRole(sortedRoles[0]);
        console.log(sortedRoles[0]);
        console.log(sortedRoles[0]);
      }
    } else {
      console.warn("User ID not found in the fetched data.");
    }
  };
  const createBusinessUnit = async (userData) => {
    try {
      const { getBusinessUnits } = await import("../../Utility/utility");
      const data = await getBusinessUnits(userData.organizationId);

      // Filter the data based on the search value
      let filteredData = data;

      // Check if there are no business units
      if (filteredData.length === 0) {
        const demoBusinessUnit = {
          name: "Demo",
          createdBy: userData.userName,
          isDefault: true, // or false based on your logic
          delete: false,
          createdDate: new Date().toISOString(),
          organizationId: userData.organizationId,
        };

        // Add "Demo Business Unit" to the backend
        try {
          const sessionToken = localStorage.getItem("sessionToken");
          const response = await fetch(`${BASE_URL}/BusinessUnits`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
              ...(sessionToken && { "X-Session-Token": sessionToken }),
            },
            body: JSON.stringify(demoBusinessUnit),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          await response.json();
          // Update the rows state with the demo business unit
        } catch (error) {
          console.error("Error adding Demo Client:", error);
        }
      } else {
        // Update rows if data is already present
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  // Step 2: Toggle chat window visibility
  const toggleChatWindow = () => {
    updateDisplayChatWindowValue(!isChatWindowVisible);
  };
  const handleNotifactionWindow = () => {
    updateNotificationWindowValue(!isNotificationWindowVisible);
  };
  const handleDrawerClose = (value) => {
    updateDrawerMenu(value);
    const userDataJSON = localStorage.getItem("token");

    if (value === false) {
      if (userDataJSON) {
        const userData = JSON.parse(userDataJSON);

        const firstLetterOfFirstName = userData.firstName.charAt(0);
        const firstLetterOfLastName = userData.lastName.charAt(0);
        setUserName(firstLetterOfFirstName + firstLetterOfLastName);

        // Make sure 'email' property exists in your data.
      }

      drawerWidth = 50;
    } else {
      if (userDataJSON) {
        const userData = JSON.parse(userDataJSON);

        const firstLetterOfFirstName = userData.firstName;
        const firstLetterOfLastName = userData.lastName;
        setUserName(firstLetterOfFirstName + firstLetterOfLastName);

        // Make sure 'email' property exists in your data.
      }

      drawerWidth = 240;
    }
    setOpen(value);
  };

  useEffect(() => {
    if (window.performance) {
      if (performance.navigation.type == 1) {
        // Perform action only on page reload or direct navigation
      } else {
        if (isDirectNavigation === false) handleLogout();
      }
    }
  }, []);

  const handleLogout = async () => {
    setSelecteAdminItem("");
    // Terminate session on server
    const sessionToken = localStorage.getItem("sessionToken");
    const tokenData = localStorage.getItem("token");
    if (sessionToken && tokenData) {
      try {
        const userData = JSON.parse(tokenData);
        await fetch(`${BASE_URL}/api/SessionManagement/logout-all`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "X-Session-Token": sessionToken,
          },
        });
      } catch (error) {
        console.error("Session logout error:", error);
      }
    }
    localStorage.removeItem("token");
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("CopilotToken");
    history.replace("/login");
  };
  const navigate = (value) => {
    history.push({
      pathname: value,
    });
  };
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  // replaced createTheme with this createMuiTheme.
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          type: prefersDarkMode ? "dark" : "light",
        },
        typography: {
          fontFamily: '"Poppins", sans-serif',
        },
      }),
    [prefersDarkMode]
  );

  const handleChange = (event) => {
    handleSetValueDefaultBusinessunit(event.target.value); // Update selected business unit
  };

  // Empty dependency array to run this effect only once on component mount.

  const routeComponents = {
    "/home": <WorkloadFileImport />,
    "/dashboard": <DashboardPage />,
    "/workloadFileImport": <WorkloadFileImport />,
    "/bulkFormImport": <BulkFormImport />,
    "/displayAndEditFile": <DispalyAndEditFile />,
    "/extractionReview": <ExtractionApprovalReviewProcess />,
    "/displayExtractionView": <DisplayExtractionView />,
    "/approval": <ApprovalReviewProcess />,
    "/export": <ExportFunctionality />,
    "/reports": <ReportsProcess />,
    "/approvalReviewProcess": <ApprovalReviewProcess />,
    "/userRoleProfile": <UserRoleProfile />,
    "/businessUnit": <BusinessUnit />,
    "/systemLink": <AdminSystemLinks />,
    "/organisation": <Organisation />,
    "/invoice": <Invoice />,
    "/userSettings": <UserSettings />,
    "/rejections": <RejectionsFunction />,
    "/extractionApproval": <ExtractionApprovalReviewProcess />,

    // Add more routes and components as needed
  };

  // Get the component to render based on the current pathname
  const currentPath = history.location.pathname;

  // SECURITY FIX: Defense-in-depth role guard inside the Dashboard component.
  // The outer AdminRoute in mainApp.js reads role from localStorage which can be
  // tampered with by an attacker. This second guard uses server-verified role state
  // (set from the /users/{id}/{orgId} API call in getUser) to block admin-only pages
  // for non-admin users.  Only activates once userRole has been resolved (non-empty),
  // to avoid blocking real admins during the brief initial loading window.
  const adminOnlyPaths = [
    "/userRoleProfile",
    "/businessUnit",
    "/systemLink",
    "/organisation",
    "/invoice",
    "/userSettings",
  ];
  const isUserAdmin = userRole === "Admin" || isSuperAdmin;
  const componentToRender = (() => {
    if (userRole !== "" && !isUserAdmin && adminOnlyPaths.includes(currentPath)) {
      // Non-admin reached an admin-only path — redirect to dashboard
      history.replace("/dashboard");
      return routeComponents["/dashboard"];
    }
    return routeComponents[currentPath] || <WorkloadFileImport />;
  })();

  useEffect(() => {
    setSelectedMenu(currentPath.substring(1));
  }, [currentPath]);

  useEffect(() => {
    if (selectedMenu != "systemadmin" && selectedMenu != "undefined" && selectedMenu != null) {
      setpreviousSelectedMenu(selectedMenu);
    }
  }, [selectedMenu]);

  const sideMenuIconContainerStyle = {
    minWidth: "50px",
    marginLeft: 0,
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const sideMenuImageStyle = {
    width: 20,
    height: 20,
    objectFit: "contain",
    display: "block",
    padding: 0,
    margin: 0,
  };

  const sideMenuVectorIconStyle = {
    width: 20,
    height: 20,
    color: "white",
    margin: 0,
    padding: 0,
    display: "block",
  };

  const getIconFilter = (isSelected) =>
    isSelected
      ? "brightness(0) saturate(100%) invert(53%) sepia(92%) saturate(382%) hue-rotate(165deg)"
      : "none";

  const handleSupportClick = () => {
    setSelecteAdminItem("");
    setSelectedMenu("support");
    const email = "support@complyexchange.com";
    const subject = "Support Request";
    const body = "Please describe your support request here.";
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(mailtoUrl, "_blank");
  };

  // Access rules for each role — enforces Maker/Checker separation of duties:
  // Maker: can initiate (upload, extract) but CANNOT approve/reject
  // Checker: can approve/reject but CANNOT initiate uploads/extractions
  // Admin: full access to all features
  const accessRules = {
    Maker: {
      accessibleTabs: [
        "workloadFileImport",
        "bulkFormImport",
        "extractionReview",
        "rejections",
        "export",
        "reports",
        "support",
        "dashboard",
      ],
      alertMessage:
        "You do not have permission to access this feature. Your role (Maker) can upload and extract data, but cannot approve or reject.",
    },
    Checker: {
      accessibleTabs: [
        "approval",
        "extractionReview",
        "rejections",
        "export",
        "reports",
        "support",
        "dashboard",
      ],
      alertMessage:
        "You do not have permission to access this feature. Your role (Checker) can approve and reject data, but cannot upload or extract.",
    },
    Admin: {
      accessibleTabs: [
        "workloadFileImport",
        "bulkFormImport",
        "extractionReview",
        "approval",
        "rejections",
        "export",
        "reports",
        "settings",
        "support",
        "dashboard",
      ],
      alertMessage: "You do not have permission to access this feature in your trial version.",
    },
  };
  // Check if the user has access to a specific tab
  const hasAccess = (tab) => accessRules[userRole]?.accessibleTabs.includes(tab);

  // Show alert message
  const showPermissionAlert = () => {
    // alert(accessRules[userRole]?.alertMessage || "Access denied.");
    setPopupMessage(accessRules[userRole]?.alertMessage || "Access denied.");
    setOpenPopup(true);
  };

  const [organizations, setOrganizations] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  // Add this useEffect to fetch organizations and users
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isSuperAdmin) {
          const orgResponse = await fetch(
            `${BASE_URL}/Organization/${getUserIdFromLocalStorage().userId}/${
              getUserIdFromLocalStorage().organizationId
            }`,
            {
              headers: {
                Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                ...(localStorage.getItem("sessionToken") && {
                  "X-Session-Token": localStorage.getItem("sessionToken"),
                }),
              },
            }
          );
          if (orgResponse.ok) {
            const orgData = await orgResponse.json();

            // Filter out invalid entries and remove duplicates by name
            const uniqueNameMap = new Map();

            // Keep only the first occurrence of each name
            orgData
              .filter((org) => org && org.id && org.name)
              .forEach((org) => {
                if (!uniqueNameMap.has(org.name)) {
                  uniqueNameMap.set(org.name, org);
                }
              });

            // Convert back to array
            const uniqueOrgs = Array.from(uniqueNameMap.values());

            setOrganizations(uniqueOrgs.reverse());
          }
        } else if (userRole === "Admin") {
          // Fetch users for admin
          const userDataJSON = localStorage.getItem("token");
          if (userDataJSON) {
            const userData = JSON.parse(userDataJSON);
            const usersResponse = await fetch(
              `${BASE_URL}/users/getAllUsers/${userData.organizationId}`,
              {
                headers: {
                  Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                  ...(localStorage.getItem("sessionToken") && {
                    "X-Session-Token": localStorage.getItem("sessionToken"),
                  }),
                },
              }
            );
            if (usersResponse.ok) {
              const usersData = await usersResponse.json();
              setUsers(usersData.filter((user) => user.isDeleted === false));
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [isSuperAdmin, userRole]);

  return (
    <ThemeProvider theme={theme}>
      <StylesThemeProvider theme={theme}>
        <div className={classes.root}>
          {isTourCompleted == false && <ShepherdTour />}
          {/* <ShepherdTour /> */}
          <Drawer
            variant="permanent"
            style={{
              position: "relative",
              whiteSpace: "nowrap",
              width: open ? 240 : 72,
              flexShrink: 0,
              border: "none",
              background: "transparent",
              overflow: "hidden",
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: open
                  ? theme.transitions.duration.enteringScreen
                  : theme.transitions.duration.leavingScreen,
              }),
            }}
            classes={{
              paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            open={open}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontFamily: fontFamily,
                marginTop: "10px",
                marginBottom: "30px",
              }}
            >
              <img
                src={open ? complyExtractorLogoExpanded : ceLogoCollapsed}
                alt="Comply Extractor"
                style={{
                  height: open ? 50 : 40,
                  width: open ? 210 : 50,
                  // objectFit: "contain",
                }}
              />
            </div>
            <ListItem
              button
              disableRipple
              component="div"
              data-testid="dashboard"
              to={hasAccess("dashboard") ? "/dashboard" : undefined}
              onClick={() => {
                if (hasAccess("dashboard")) {
                  setSelectedMenu("dashboard");
                  setSelecteAdminItem("");
                  navigate("/dashboard");
                } else {
                  showPermissionAlert();
                }
              }}
              title=""
              style={{
                backgroundColor: selectedMenu === "dashboard" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={dashboardIcon}
                  alt="Dashboard"
                  title="Dashboard"
                  height="20"
                  width="20"
                  style={{
                    ...sideMenuImageStyle,
                    filter: getIconFilter(selectedMenu === "dashboard"),
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "dashboard")}>
                    Dashboard
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              disableRipple
              component="div"
              data-testid="file-import"
              to={hasAccess("workloadFileImport") ? "/workloadFileImport" : undefined}
              onClick={() => {
                if (hasAccess("workloadFileImport")) {
                  setSelectedMenu("workloadFileImport");
                  setSelecteAdminItem("");
                  navigate("/workloadFileImport");
                } else {
                  showPermissionAlert();
                }
              }}
              title=""
              style={{
                backgroundColor: selectedMenu === "workloadFileImport" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={fileImportIcon}
                  alt="Workload File Import"
                  title="File Import"
                  height="20"
                  width="20"
                  style={{
                    ...sideMenuImageStyle,
                    filter: getIconFilter(selectedMenu === "workloadFileImport"),
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    variant="body2"
                    style={menuItemStyle(selectedMenu, "workloadFileImport")}
                  >
                    File Import
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              disableRipple
              component="div"
              data-testid="bulk-form-import"
              to={hasAccess("bulkFormImport") ? "/bulkFormImport" : undefined}
              onClick={() => {
                if (hasAccess("bulkFormImport")) {
                  setSelectedMenu("bulkFormImport");
                  setSelecteAdminItem("");
                  navigate("/bulkFormImport");
                } else {
                  showPermissionAlert();
                }
              }}
              title=""
              style={{
                backgroundColor: selectedMenu === "bulkFormImport" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={bulkFormImportIcon}
                  alt="Bulk Form Import"
                  title="Bulk Form Import"
                  height="20"
                  width="20"
                  style={{
                    ...sideMenuImageStyle,
                    filter: getIconFilter(selectedMenu === "bulkFormImport"),
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "bulkFormImport")}>
                    Bulk Form Import
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              disableRipple
              component="div"
              data-testid="extraction-review"
              to={hasAccess("extractionReview") ? "/extractionReview" : undefined}
              onClick={() => {
                if (hasAccess("extractionReview")) {
                  setSelectedMenu("extractionReview");
                  setSelecteAdminItem("");
                  navigate("/extractionReview");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "extractionReview" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={extractionReviewIcon}
                  alt="Extraction Review"
                  title="Extraction Review"
                  height="20"
                  width="20"
                  style={{
                    ...sideMenuImageStyle,
                    filter: getIconFilter(selectedMenu === "extractionReview"),
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    variant="body2"
                    style={menuItemStyle(selectedMenu, "extractionReview")}
                  >
                    Extraction Review
                  </Typography>
                }
              />
            </ListItem>
            {(userRole === "Checker" || userRole === "Admin") && (
              <ListItem
                button
                disableRipple
                component="div"
                data-testid="approval-review"
                to="/approval"
                onClick={() => {
                  setSelectedMenu("approval");
                  setSelecteAdminItem("");
                  navigate("/approval");
                }}
                style={{
                  backgroundColor: selectedMenu === "approval" ? "white" : "transparent",
                  borderRadius: 3.67,
                  marginBottom: 10,
                  marginLeft: 10,
                  width: "calc(100% - 20px)",
                }}
              >
                <ListItemIcon style={sideMenuIconContainerStyle}>
                  <img
                    src={approvalProcessIcon}
                    alt="Approval"
                    height="20"
                    title="Approval Process"
                    width="20"
                    style={{
                      ...sideMenuImageStyle,
                      filter: getIconFilter(selectedMenu === "approval"),
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography variant="body2" style={menuItemStyle(selectedMenu, "approval")}>
                      Approval Process
                    </Typography>
                  }
                />
              </ListItem>
            )}
            <ListItem
              button
              disableRipple
              component="div"
              data-testid="reject"
              to={hasAccess("rejections") ? "/rejections" : undefined}
              onClick={() => {
                if (hasAccess("rejections")) {
                  setSelectedMenu("rejections");
                  setSelecteAdminItem("");
                  navigate("/rejections");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "rejections" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={rejectionsIcon}
                  alt="Rejections"
                  height="20"
                  title="Rejections"
                  width="20"
                  style={{
                    ...sideMenuImageStyle,
                    filter: getIconFilter(selectedMenu === "rejections"),
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "rejections")}>
                    Rejections
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              disableRipple
              component="div"
              data-testid="export"
              to={hasAccess("export") ? "/export" : undefined}
              onClick={() => {
                if (hasAccess("export")) {
                  setSelectedMenu("export");
                  setSelecteAdminItem("");
                  navigate("/export");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "export" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={exportIcon}
                  alt="Export"
                  height="20"
                  width="20"
                  title="Export"
                  style={{
                    ...sideMenuImageStyle,
                    filter: getIconFilter(selectedMenu === "export"),
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "export")}>
                    Export
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              data-testid="report"
              button
              disableRipple
              component="div"
              to="/reports"
              onClick={() => {
                if (hasAccess("reports")) {
                  setSelectedMenu("reports");
                  setSelecteAdminItem("");
                  navigate("/reports");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "reports" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={reportsIcon}
                  alt="Reports"
                  height="20"
                  width="20"
                  title="Reports"
                  style={{
                    ...sideMenuImageStyle,
                    filter: getIconFilter(selectedMenu === "reports"),
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "reports")}>
                    Reports
                  </Typography>
                }
              />
            </ListItem>
            {userRole === "Admin" && (
              <ListItem
                data-testid="settings"
                disableRipple
                ref={settingsRef}
                onMouseEnter={() => {
                  showSettingsMenu();
                  // Auto-scroll to ensure Settings menu is visible
                  if (settingsRef.current) {
                    settingsRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                      inline: "nearest",
                    });
                  }
                }}
                onMouseLeave={() => {
                  hideSettingsMenu();
                }}
                onClick={handleSystemAdminClick}
                style={{
                  backgroundColor:
                    selectedMenu === "systemadmin" ||
                    selectedMenu === "userRoleProfile" ||
                    selectedMenu === "businessUnit" ||
                    selectedMenu === "systemLink" ||
                    selectedMenu === "userSettings" ||
                    selectedMenu === "organisation" ||
                    selectedMenu === "invoice"
                      ? "white"
                      : "transparent",
                  borderRadius: 3.67,
                  marginBottom: 10,
                  marginLeft: 10,
                  width: "calc(100% - 20px)",
                  cursor: "pointer",
                }}
              >
                <ListItemIcon style={sideMenuIconContainerStyle}>
                  <img
                    src={settingsIcon}
                    alt="System Admin"
                    title="Settings"
                    height="20"
                    width="20"
                    style={{
                      ...sideMenuImageStyle,
                      filter: getIconFilter(
                        [
                          "systemadmin",
                          "userRoleProfile",
                          "businessUnit",
                          "systemLink",
                          "userSettings",
                          "organisation",
                          "invoice",
                        ].includes(selectedMenu)
                      ),
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography
                      variant="body2"
                      style={{
                        color:
                          selectedMenu === "systemadmin" ||
                          selectedMenu === "userRoleProfile" ||
                          selectedMenu === "businessUnit" ||
                          selectedMenu === "systemLink" ||
                          selectedMenu === "organisation" ||
                          selectedMenu === "invoice" ||
                          selectedMenu === "userSettings"
                            ? "#2aa7e0"
                            : "white",
                        fontSize: 14,
                        fontFamily: fontFamily,
                        fontWeight: 300,
                      }}
                    >
                      Settings
                    </Typography>
                  }
                />
              </ListItem>
            )}
            <ListItem
              button
              disableRipple
              data-testid="support"
              // onClick={() => { handleHelpClick() }}
              onMouseEnter={() => showHelpMenu()}
              onMouseLeave={() => hideHelpMenu()}
              ref={helpRef}
              style={{
                backgroundColor: selectedMenu === "help" ? "white" : "transparent",
                borderRadius: 3.67,
                marginBottom: 10,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={helpIcon}
                  alt="Help"
                  title="Help"
                  height="20"
                  width="20"
                  style={sideMenuImageStyle}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "help")}>
                    Help
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              disableRipple
              title={open ? "Collapse Menu" : "Expand Menu"}
              onClick={() => handleDrawerClose(!open)}
              style={{
                color: "white",
                marginTop: "auto",
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={open ? collapseMenuOnIcon : collapseMenuOffIcon}
                  alt={open ? "Collapse Menu" : "Expand Menu"}
                  height="20"
                  width="20"
                  style={sideMenuImageStyle}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    variant="body2"
                    style={{
                      color: "white",
                      fontSize: 14,
                      fontFamily: fontFamily,
                      fontWeight: 300,
                    }}
                  >
                    Collapse Menu
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              disableRipple
              title="Logout"
              onClick={handleLogout}
              style={{
                color: "white",
                marginBottom: 20,
                marginLeft: 10,
                width: "calc(100% - 20px)",
              }}
            >
              <ListItemIcon style={sideMenuIconContainerStyle}>
                <img
                  src={logoutIcon}
                  alt="Logout"
                  height="20"
                  width="20"
                  style={sideMenuImageStyle}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "")}>
                    Logout
                  </Typography>
                }
              />
            </ListItem>

            {/* Version label at bottom center */}
            {/* <div
              style={{
                display: "flex",

                // justifyContent: "center",
                // alignItems: "center",
                marginBottom: 10,
                marginLeft: open === true ? 49 : 14,
                color: "white",
                fontSize: "14px",
                opacity: 1,
                fontFamily: fontFamily,
              }}
            >
              {open ? `version: ${appVersion}` : `v: ${appVersion}`}
            </div> */}
          </Drawer>
          <main
            className={classes.content}
            style={{
              backgroundColor: "#f0f2f5",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                height: "64px",
                minHeight: "64px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 20,
                paddingRight: 10,
                backgroundColor: "white",
                borderBottom: "1px solid #e8eaec",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", height: "36px" }}>
                <span
                  style={{
                    color: InstaColors.primary,
                    fontFamily: fontFamily,
                    fontWeight: 400,
                    fontSize: "24px",
                  }}
                >
                  {" "}
                  {menuTitles[selectedMenu] ? (
                    <>{menuTitles[selectedMenu]}</>
                  ) : selectedMenu === "systemadmin" ? (
                    menuTitles[previousSelectedMenu]
                  ) : (
                    selectedMenu
                  )}
                </span>
              </div>
              {/* <Loader /> */}
              <div style={{ display: "flex", marginLeft: "auto", marginRight: 10 }}>
                {" "}
                {isPackProcessStarted === true && isProcessing === false && (
                  //   < DataSaverOnIcon onClick={() => {
                  //   handleProcessingDialogue(true);
                  // }} style={{ color: InstaColors.primary, fontSize: 30 }} />
                  <div
                    className="processing-button-container"
                    style={{
                      padding: "12px 20px",
                      borderRadius: "8px",
                      height: 35,
                      backgroundColor: "white",
                      boxShadow: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "fit-content",
                      cursor: isPackProcessStarted && !isProcessing ? "pointer" : "default",
                    }}
                    onClick={() => {
                      if (isPackProcessStarted && !isProcessing) {
                        handleProcessingDialogue(true);
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <CircularProgress size={20} style={{ color: InstaColors.primary }} />

                      <span
                        style={{
                          color: "#555",
                          fontFamily: "sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Processing
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {/* Add organization/user dropdowns with search */}
              {(isSuperAdmin || userRole === "Admin") && (
                <div style={{ marginLeft: 20, width: isSuperAdmin ? 192 : 180 }}>
                  {isSuperAdmin && (
                    <Autocomplete
                      options={organizations}
                      getOptionLabel={(option) => option.name || ""}
                      value={defaultOrganization}
                      onChange={(event, newValue) => {
                        handleSetValueDefaultOrganization(newValue);
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      renderInput={(params) => {
                        const { InputProps, ...rest } = params;
                        return (
                          <TextField
                            {...rest}
                            variant="outlined"
                            placeholder="Search Organization"
                            size="small"
                            InputProps={{
                              ...InputProps,
                              style: {
                                ...InputProps.style,
                                padding: "0",
                                height: "36px",
                                fontSize: "14px",
                                backgroundColor: InstaColors.surfaceLight,
                                borderRadius: "10px",
                                border: "none",
                              },
                              inputProps: {
                                ...params.inputProps,
                                style: {
                                  ...params.inputProps?.style,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  paddingRight: "56px",
                                },
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  border: "none",
                                },
                                "&:hover fieldset": {
                                  border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                  border: "none",
                                },
                              },
                            }}
                          />
                        );
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: "1.2em",
                            maxHeight: "2.7em",
                            padding: "8px 16px",
                          }}
                        >
                          {option.name}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value?.id}
                      noOptionsText="No organizations found"
                      popupIcon={
                        <img src={downArrowIcon} alt="" style={{ width: 11, height: 11 }} />
                      }
                      fullWidth
                    />
                  )}

                  {userRole === "Admin" && !isSuperAdmin && (
                    <Autocomplete
                      options={users}
                      getOptionLabel={(option) => `${option.email}` || ""}
                      value={defaultUser}
                      onChange={(event, newValue) => {
                        handleSetValueDefaultUser(newValue);
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchTerm = inputValue.toLowerCase().trim();
                        return options.filter((option) =>
                          option.email.toLowerCase().includes(searchTerm)
                        );
                      }}
                      renderInput={(params) => {
                        const { InputProps, ...rest } = params;
                        return (
                          <TextField
                            {...rest}
                            InputProps={{
                              ...InputProps,
                              style: {
                                ...InputProps.style,
                                padding: "0",
                                height: "36px",
                                fontSize: "14px",
                                backgroundColor: InstaColors.surfaceLight,
                                borderRadius: "10px",
                                border: "none",
                              },
                              inputProps: {
                                ...params.inputProps,
                                style: {
                                  ...params.inputProps?.style,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  paddingRight: "56px",
                                },
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  border: "none",
                                },
                                "&:hover fieldset": {
                                  border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                  border: "none",
                                },
                              },
                            }}
                            variant="outlined"
                            placeholder="Search User"
                            size="small"
                          />
                        );
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: "1.2em",
                            maxHeight: "2.7em",
                            padding: "8px 16px",
                          }}
                        >
                          {option.email}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value?.id}
                      noOptionsText="No users found"
                      popupIcon={
                        <img src={downArrowIcon} alt="" style={{ width: 11, height: 11 }} />
                      }
                      fullWidth
                    />
                  )}
                </div>
              )}

              {/* Update business unit dropdown to use Autocomplete */}
              <div style={{ marginLeft: 15, marginRight: 15, width: 180 }} data-testid="clients">
                <Autocomplete
                  options={businessUnitsList}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    businessUnitsList.find((unit) => unit.name === defaultBusinessunit) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({ target: { value: newValue?.name || "" } });
                  }}
                  renderInput={(params) => {
                    // Modify the input props to handle text overflow
                    const { InputProps, ...rest } = params;
                    return (
                      <TextField
                        {...rest}
                        variant="outlined"
                        placeholder="Search Client"
                        size="small"
                        InputProps={{
                          ...InputProps,
                          style: {
                            ...InputProps.style,
                            padding: "0",
                            height: "36px",
                            fontSize: "14px",
                            backgroundColor: InstaColors.surfaceLight,
                            borderRadius: "10px",
                            border: "none",
                          },
                          // Add styles to the input element itself
                          inputProps: {
                            ...params.inputProps,
                            style: {
                              ...params.inputProps?.style,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              paddingRight: "56px", // Make room for the close and dropdown icons
                            },
                          },
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none",
                            },
                            "&:hover fieldset": {
                              border: "none",
                            },
                            "&.Mui-focused fieldset": {
                              border: "none",
                            },
                          },
                        }}
                      />
                    );
                  }}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: "1.2em",
                        maxHeight: "2.7em",
                        padding: "8px 16px",
                      }}
                    >
                      {option.name}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  noOptionsText="No clients found"
                  popupIcon={<img src={downArrowIcon} alt="" style={{ width: 11, height: 11 }} />}
                  fullWidth
                />
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <div data-testid="copilot" style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={ceBubbleIcon}
                    onClick={toggleChatWindow}
                    height="36px"
                    width="36px"
                    alt="Copilot"
                    style={{ cursor: "pointer", display: "block" }}
                  />
                </div>
                <div
                  data-testid="notifications"
                  className="notification-icon-container"
                  style={{ display: "flex", alignItems: "center", position: "relative" }}
                >
                  <img
                    onClick={handleNotifactionWindow}
                    src={notificationIcon}
                    height="36px"
                    width="36px"
                    alt="Notification"
                    style={{ cursor: "pointer", display: "block" }}
                  />
                  {notifications?.length !== 0 && (
                    <span onClick={handleNotifactionWindow} className="notification-badge">
                      {notifications.length}
                    </span>
                  )}
                </div>
                <ProfileDropdown />
              </div>
            </div>
            {componentToRender}
            {isChatWindowVisible && <Chat />}
            {isNotificationWindowVisible && <Notifications />}
          </main>

          <CustomModal
            open={openPopup}
            onClose={() => setOpenPopup(false)}
            title="Access Denied"
            description={popupMessage}
          />
          {isHelpHovered && (
            <div
              style={{
                position: "fixed",
                left: open ? "240px" : "72px",
                top: helpRef.current?.getBoundingClientRect().top || 0,
                backgroundImage: "none",
                backgroundColor: "#2AA7E0",
                width: "188px",
                boxShadow: "none",
                zIndex: 1004,
                fontFamily: fontFamily,
                borderRadius: "4px",
                overflow: "hidden",
              }}
              onMouseEnter={() => showHelpMenu()}
              onMouseLeave={() => hideHelpMenu()}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 10px",
                  margin: "4px 8px",
                  borderRadius: "4px",
                  fontFamily: fontFamily,
                  cursor: "pointer",
                  color: "white",
                  backgroundColor: "transparent",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.color = "#2AA7E0";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "white";
                }}
                onClick={() => {
                  handleTourGuide();
                  setIsHelpHovered(false);
                }}
              >
                <HelpOutlineIcon style={{ width: 22, height: 22, marginRight: 20 }} />
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 300,
                    fontFamily: fontFamily,
                  }}
                >
                  Help Guide
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 10px",
                  margin: "4px 8px",
                  borderRadius: "4px",
                  fontFamily: fontFamily,
                  cursor: "pointer",
                  color: "white",
                  backgroundColor: "transparent",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.color = "#2AA7E0";
                  const img = e.currentTarget.querySelector("img");
                  if (img) img.src = "./Support(B).png";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "white";
                  const img = e.currentTarget.querySelector("img");
                  if (img) img.src = "./Support(W).png";
                }}
                onClick={() => {
                  handleSupportClick();
                  setIsHelpHovered(false);
                }}
              >
                {" "}
                <img
                  src="./Support(W).png"
                  alt="Help"
                  height="20"
                  title="Help"
                  width="20"
                  style={{ width: 22, height: 22, marginRight: 20 }}
                />
                {/* <SupportAgentIcon style={{ width: 22, height: 22, marginRight: 20 }} /> */}
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 300,
                    fontFamily: fontFamily,
                  }}
                >
                  Contact Us
                </span>
              </div>
            </div>
          )}

          {isSettingsHovered && (
            <div
              style={{
                position: "fixed", // Change to fixed positioning
                left: open ? "240px" : "72px", // Adjust based on drawer width
                top: settingsRef.current?.getBoundingClientRect().top || 0, // Align with settings item
                backgroundImage: "none",
                backgroundColor: "#2AA7E0",
                width: "240px",
                boxShadow: "none",
                zIndex: 1004,
                fontFamily: fontFamily,
                borderRadius: "4px",
                overflow: "hidden",
              }}
              onMouseEnter={() => showSettingsMenu()}
              onMouseLeave={() => hideSettingsMenu()}
            >
              {menuItems
                .filter((subItem) => isSuperAdmin || subItem.id !== "organization") // Only include 'organization' if isSuperAdmin is true
                .filter(
                  (subItem) => isSuperAdmin || userRole === "Admin" || subItem.id !== "invoice"
                ) // Include 'invoice' for both SuperAdmin and Admin
                .filter((subItem) => !isSuperAdmin || subItem.id !== "userSettings") // Hide 'Admin Settings' for super admins
                .map((subItem) => (
                  <div
                    key={subItem.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "10px 10px",
                      fontFamily: fontFamily,
                      cursor: "pointer",
                      color: selectAdminItem === subItem.label ? "#2aa7e0" : "white",
                      backgroundColor: selectAdminItem === subItem.label ? "white" : "transparent",
                      transition: "background-color 0.2s",
                      borderRadius: 3.67,
                      margin: selectAdminItem === subItem.label ? "4px 8px" : "4px 8px",
                    }}
                    onMouseEnter={(e) => {
                      if (selectAdminItem !== subItem.label) {
                        e.currentTarget.style.backgroundColor = "white";
                        e.currentTarget.style.color = "#2AA7E0";
                        const img = e.currentTarget.querySelector("img");
                        if (img)
                          img.style.filter =
                            "brightness(0) saturate(100%) invert(56%) sepia(87%) saturate(370%) hue-rotate(164deg) brightness(108%) contrast(88%)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectAdminItem !== subItem.label) {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "white";
                        const img = e.currentTarget.querySelector("img");
                        if (img) img.style.filter = "brightness(0) invert(1)";
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (subItem.id === "users") {
                        if (hasAccess("settings")) {
                          navigate("/userRoleProfile");
                          setSelectedMenu("userRoleProfile");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                      } else if (subItem.id === "business") {
                        if (hasAccess("settings")) {
                          navigate("/businessUnit");
                          setSelectedMenu("businessUnit");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                      } else if (subItem.id === "userSettings") {
                        // Admin Settings - accessible to admins and super admins only
                        if (userRole === "Admin" || isSuperAdmin) {
                          navigate("/userSettings");
                          setSelectedMenu("userSettings");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                      } else if (subItem.id === "organization") {
                        if (hasAccess("settings")) {
                          navigate("/organisation");
                          setSelectedMenu("organisation");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                      } else if (subItem.id === "invoice") {
                        // Invoice - accessible to super admins and org admins
                        if (isSuperAdmin || userRole === "Admin") {
                          navigate("/invoice");
                          setSelectedMenu("invoice");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                        // }  else if (subItem.id === "billing") {
                        //     navigate("/billing");
                        //     setSelectedMenu("billing");
                        //     setSelecteAdminItem(subItem.label);
                        //   } else {
                        //     showPermissionAlert();
                        //   }
                      }
                      hideSettingsMenuNow();
                    }}
                  >
                    <img
                      src={subItem.icon}
                      alt={subItem.label}
                      style={{
                        width: 22,
                        height: 22,
                        marginRight: 20,
                        filter:
                          selectAdminItem === subItem.label
                            ? subItem.id === "users"
                              ? "none"
                              : "brightness(0) saturate(100%) invert(56%) sepia(87%) saturate(370%) hue-rotate(164deg) brightness(108%) contrast(88%)"
                            : "brightness(0) invert(1)",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 300,
                        fontFamily: fontFamily,
                      }}
                    >
                      {subItem.label}
                    </span>
                  </div>
                ))}
            </div>
          )}
        </div>
      </StylesThemeProvider>
    </ThemeProvider>
  );
}
